<sub-filtro-usuarios
    [listaUsuarios]="listaUsuarios"
    [(filtroUsuario)]="filterUsersSelected"
></sub-filtro-usuarios>
